import { api } from './apiClient';
import { ApiError } from './apiError';

/**
 * Uploads a file straight to cloud storage and returns its stored path.
 * folder: service-photos | signatures | bills | voice-notes | company | attachments
 */
export type UploadFolder = 'service-photos' | 'signatures' | 'bills' | 'voice-notes' | 'company' | 'attachments';

export async function uploadFile(file: File, folder: UploadFolder): Promise<string> {
  const { data } = await api.post<{ data: { uploadUrl: string; path: string } }>('/uploads/signed-url', { folder, fileName: file.name, contentType: file.type });
  const res = await fetch(data.uploadUrl, { method: 'PUT', headers: { 'Content-Type': file.type }, body: file });
  if (!res.ok) throw new ApiError('Upload failed. Please try again.', res.status);
  return data.path;
}

const cache = new Map<string, { url: string; expires: number }>();
/** Short-lived link to view a private file (cached for 50 minutes). */
export async function viewUrl(path: string): Promise<string> {
  const hit = cache.get(path);
  if (hit && hit.expires > Date.now()) return hit.url;
  const { data } = await api.get<{ data: { url: string } }>('/uploads/view-url', { path });
  cache.set(path, { url: data.url, expires: Date.now() + 50 * 60 * 1000 });
  return data.url;
}
